var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"content",style:({paddingTop: _vm.HEADER_HEIGHT})},[_c('span',[_vm._v("Страница не найдена")]),_c('router-link',{staticClass:"button button_small",attrs:{"to":{ name: 'Home' }}},[_vm._v("На главную")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }